import PropTypes from 'prop-types';

function Badge({ className = "", variant = "default", ...props }) {
  const baseClasses = "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2";

  let variantClasses = "";

  if (variant === "default") {
    variantClasses = "border-transparent bg-primary text-primary-foreground hover:bg-primary/80";
  } else if (variant === "secondary") {
    variantClasses = "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80";
  } else if (variant === "destructive") {
    variantClasses = "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80";
  } else if (variant === "outline") {
    variantClasses = "text-foreground";
  }

  return (
    <div className={`${baseClasses} ${variantClasses} ${className}`} {...props} />
  );
}

Badge.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'secondary', 'destructive', 'outline']),
  children: PropTypes.node,
};

Badge.defaultProps = {
  className: "",
  variant: "default",
};

export default Badge;
